import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "d-flex justify-content-between w-100 flex-column flex-lg-row" }
const _hoisted_5 = { class: "d-flex" }
const _hoisted_6 = { class: "d-flex flex-column justify-content-center fs-4 ms-3" }
const _hoisted_7 = { class: "m-0 mt-1 fw-normal" }
const _hoisted_8 = { class: "d-flex align-items-center ms-8 me-4" }
const _hoisted_9 = { class: "d-flex align-items-center fs-4 me-0 me-lg-5 date-publication justify-content-end flex-column flex-lg-row" }
const _hoisted_10 = ["data-href", "onClick"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-file-signature" }, null, -1)
const _hoisted_12 = ["data-href"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-file-signature" }, null, -1)
const _hoisted_14 = {
  key: 0,
  class: "m-0 fw-normal mt-1 text-center text-lg-start"
}
const _hoisted_15 = { class: "d-flex justify-content-between w-100 flex-column flex-lg-row" }
const _hoisted_16 = { class: "d-flex" }
const _hoisted_17 = { class: "d-flex flex-column justify-content-center fs-4 ms-3" }
const _hoisted_18 = {
  key: 0,
  class: "m-0"
}
const _hoisted_19 = {
  key: 1,
  class: "m-0 fst-italic"
}
const _hoisted_20 = { class: "m-0 mt-1 fw-normal" }
const _hoisted_21 = { class: "d-flex align-items-center ms-8 me-4" }
const _hoisted_22 = {
  key: 0,
  class: "badge badge-light p-2"
}
const _hoisted_23 = {
  key: 1,
  class: "badge badge-primary p-2"
}
const _hoisted_24 = {
  key: 2,
  class: "badge badge-danger p-2"
}
const _hoisted_25 = {
  key: 3,
  class: "badge badge-light p-2"
}
const _hoisted_26 = {
  key: 4,
  class: "badge badge-success p-2"
}
const _hoisted_27 = {
  key: 5,
  class: "badge badge-warning p-2"
}
const _hoisted_28 = {
  key: 6,
  class: "badge badge-danger p-2"
}
const _hoisted_29 = { class: "d-flex align-items-center fs-4 me-0 me-lg-5 date-publication justify-content-end flex-column flex-lg-row" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = ["data-href"]
const _hoisted_32 = ["data-href"]
const _hoisted_33 = ["data-href", "onClick"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-file-signature" }, null, -1)
const _hoisted_35 = ["data-href", "onClick"]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-file-signature" }, null, -1)
const _hoisted_37 = {
  key: 1,
  class: "m-0 fw-normal mt-1 text-center text-lg-start"
}
const _hoisted_38 = { class: "row w-100" }
const _hoisted_39 = { class: "col-12" }
const _hoisted_40 = { class: "d-flex flex-column" }
const _hoisted_41 = { class: "d-flex justify-content-center w-100 cases-wizard-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BasicCard = _resolveComponent("BasicCard")!
  const _component_SimpleCard = _resolveComponent("SimpleCard")!
  const _component_WizardItem = _resolveComponent("WizardItem")!
  const _component_WizardContainer = _resolveComponent("WizardContainer")!
  const _component_CardAccordion = _resolveComponent("CardAccordion")!
  const _component_AdmissibleDocuments = _resolveComponent("AdmissibleDocuments")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.canManageContract)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_BasicCard, {
              class: "mb-10",
              title: _ctx.cmsData.cmsInfo?.process?.title
            }, {
              default: _withCtx(() => [
                _createElementVNode("p", {
                  innerHTML: _ctx.cmsData.cmsInfo?.process?.text
                }, null, 8, _hoisted_3)
              ]),
              _: 1
            }, 8, ["title"]),
            (_ctx.sfpDossiers.length)
              ? (_openBlock(), _createBlock(_component_BasicCard, {
                  key: 0,
                  class: "mb-10",
                  title: _ctx.$t('views.portal.cases.conventionSFP.title')
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sfpDossiers, (dossier) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: dossier.id,
                        class: "my-3"
                      }, [
                        _createVNode(_component_SimpleCard, null, {
                          content: _withCtx(() => [
                            _createElementVNode("div", _hoisted_4, [
                              _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("div", _hoisted_6, [
                                  _createElementVNode("h6", _hoisted_7, _toDisplayString(_ctx.$t('views.portal.cases.conventionSFP.content.dossierNumber')) + " " + _toDisplayString(dossier.id), 1)
                                ]),
                                _createElementVNode("div", _hoisted_8, [
                                  (_ctx.getSfpEtapeStatus(dossier))
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 0,
                                        class: _normalizeClass(["badge p-2", _ctx.getSfpBadgeClass(dossier)])
                                      }, _toDisplayString(_ctx.$t('views.portal.cases.conventionSFP.content.etapeStatus.'+_ctx.getSfpEtapeStatus(dossier))), 3))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("div", null, [
                                  (_ctx.isSfpConventionSigned(dossier))
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 0,
                                        "data-href": dossier.dossierConventionSFP,
                                        class: "btn btn-primary btn-violet my-4 my-lg-0 me-0 me-lg-4",
                                        onClick: ($event: any) => (_ctx.downloadPdf($event, dossier.dossierConventionSFP))
                                      }, [
                                        _hoisted_11,
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t('views.portal.cases.conventionSFP.content.goto.signedFile')), 1)
                                      ], 8, _hoisted_10))
                                    : _createCommentVNode("", true),
                                  (_ctx.isSfpConventionToSign(dossier))
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 1,
                                        "data-href": '/signatureSFP/' + dossier.id,
                                        class: "btn btn-primary btn-violet my-4 my-lg-0 me-0 me-lg-4",
                                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args)))
                                      }, [
                                        _hoisted_13,
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t('views.portal.cases.conventionSFP.content.goto.signating')), 1)
                                      ], 8, _hoisted_12))
                                    : _createCommentVNode("", true)
                                ]),
                                (dossier.dossierLastUpdate)
                                  ? (_openBlock(), _createElementBlock("h5", _hoisted_14, _toDisplayString(_ctx.$t('views.portal.cases.conventionSFP.content.lastUpdateAt')) + " " + _toDisplayString(_ctx.formatDate(dossier.dossierLastUpdate).toLowerCase()), 1))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]),
                          _: 2
                        }, 1024)
                      ]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["title"]))
              : _createCommentVNode("", true),
            _createVNode(_component_BasicCard, {
              class: "mb-10",
              title: _ctx.$t('views.portal.cases.title')
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dossiers, (dossier, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: dossier.id,
                    class: "my-3"
                  }, [
                    _createVNode(_component_CardAccordion, {
                      context: "dossiers",
                      "id-key": dossier.id,
                      expanded: index === 0
                    }, {
                      header: _withCtx(() => [
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, [
                              (dossier.dossierName)
                                ? (_openBlock(), _createElementBlock("h5", _hoisted_18, _toDisplayString(dossier.dossierName), 1))
                                : (_openBlock(), _createElementBlock("h5", _hoisted_19, _toDisplayString(_ctx.$t('views.portal.cases.content.newCase')), 1)),
                              _createElementVNode("h6", _hoisted_20, "Dossier n° " + _toDisplayString(dossier.id), 1)
                            ]),
                            _createElementVNode("div", _hoisted_21, [
                              ([1, 2].includes(dossier.dossierStatut))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.$t('views.portal.cases.content.statusBadges.started')), 1))
                                : _createCommentVNode("", true),
                              ([3, 4, 5, 7].includes(dossier.dossierStatut))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.$t('views.portal.cases.content.statusBadges.inProgress')), 1))
                                : _createCommentVNode("", true),
                              ([6].includes(dossier.dossierStatut))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.$t('views.portal.cases.content.statusBadges.refused')), 1))
                                : _createCommentVNode("", true),
                              ([9].includes(dossier.dossierStatut))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.$t('views.portal.cases.content.statusBadges.archived')), 1))
                                : _createCommentVNode("", true),
                              ([8, 10, 11].includes(dossier.dossierStatut))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.$t('views.portal.cases.content.statusBadges.accepted')), 1))
                                : _createCommentVNode("", true),
                              ([12].includes(dossier.dossierStatut))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_ctx.$t('views.portal.cases.content.statusBadges.breaking')), 1))
                                : _createCommentVNode("", true),
                              ([13].includes(dossier.dossierStatut))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.$t('views.portal.cases.content.statusBadges.broken')), 1))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_29, [
                            (![9, 13, 12].includes(dossier.dossierStatut))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                  (dossier.dossierAccessible && ([1, 5].includes(dossier.etapeStatus.find(e => e.type === 'f1ca')?.status) || !dossier.etapeStatus.some(e => e.type === 'f1ca')))
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        "data-href": '/admissible/fiche-premier-contact/' + dossier.id,
                                        class: "btn btn-primary btn-violet my-4 my-lg-0 me-0 me-lg-4 text-nowrap",
                                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args)))
                                      }, _toDisplayString(_ctx.$t('views.portal.cases.content.goto.f1ca')), 9, _hoisted_31))
                                    : ([1, 5].includes(dossier.etapeStatus.find(e => e.type === 'fra')?.status))
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 1,
                                          "data-href": '/admissible/fiche-renseignement/' + dossier.id,
                                          class: "btn btn-primary btn-violet my-4 my-lg-0 me-0 me-lg-4 text-nowrap",
                                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args)))
                                        }, _toDisplayString(_ctx.$t('views.portal.cases.content.goto.fra')), 9, _hoisted_32))
                                      : ([8, 10, 11, 12].includes(dossier.dossierStatut) && dossier.dossierCerfa)
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 2,
                                            "data-href": dossier.dossierCerfa,
                                            class: "btn btn-primary btn-violet my-4 my-lg-0 me-0 me-lg-4",
                                            onClick: ($event: any) => (_ctx.downloadPdf($event, dossier.dossierCerfa))
                                          }, [
                                            _hoisted_34,
                                            _createTextVNode(" " + _toDisplayString(_ctx.$t('views.portal.cases.content.goto.signed')), 1)
                                          ], 8, _hoisted_33))
                                        : _createCommentVNode("", true),
                                  (dossier.dossierCerfaAvenant)
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 3,
                                        "data-href": dossier.dossierCerfaAvenant,
                                        class: "btn btn-primary btn-violet my-4 my-lg-0 me-0 me-lg-4",
                                        onClick: ($event: any) => (_ctx.downloadPdf($event, dossier.dossierCerfaAvenant))
                                      }, [
                                        _hoisted_36,
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t('views.portal.cases.content.goto.avenantSigned')), 1)
                                      ], 8, _hoisted_35))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            (dossier.dossierLastUpdate)
                              ? (_openBlock(), _createElementBlock("h5", _hoisted_37, _toDisplayString(_ctx.$t('views.portal.cases.content.lastUpdateAt')) + " " + _toDisplayString(_ctx.formatDate(dossier.dossierLastUpdate).toLowerCase()), 1))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      content: _withCtx(() => [
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("div", _hoisted_39, [
                            _createElementVNode("div", _hoisted_40, [
                              _createElementVNode("h3", null, _toDisplayString(_ctx.$t('views.portal.cases.content.steps')), 1),
                              _createElementVNode("div", _hoisted_41, [
                                _createVNode(_component_WizardContainer, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_WizardItem, {
                                      title: _ctx.$t('views.portal.cases.content.stepsDetail.f1ca'),
                                      icon: "fa-solid fa-rectangle-list",
                                      completed: [2, 3].includes(dossier.etapeStatus.find(e => e.type === 'f1ca')?.status),
                                      active: [1, 5].includes(dossier.etapeStatus.find(e => e.type === 'f1ca')?.status),
                                      isLast: false
                                    }, null, 8, ["title", "completed", "active"]),
                                    _createVNode(_component_WizardItem, {
                                      title: _ctx.$t('views.portal.cases.content.stepsDetail.f1ce'),
                                      icon: "fa-solid fa-building",
                                      completed: [2, 3].includes(dossier.etapeStatus.find(e => e.type === 'f1ce')?.status),
                                      active: [1, 5].includes(dossier.etapeStatus.find(e => e.type === 'f1ce')?.status),
                                      isLast: false
                                    }, null, 8, ["title", "completed", "active"]),
                                    _createVNode(_component_WizardItem, {
                                      title: _ctx.$t('views.portal.cases.content.stepsDetail.modalites'),
                                      icon: "fa-solid fa-money-bill",
                                      completed: [3].includes(dossier.etapeStatus.find(e => e.type === 'modalites_re')?.status),
                                      active: [2].includes(dossier.etapeStatus.find(e => e.type === 'modalites_re')?.status),
                                      isLast: false
                                    }, null, 8, ["title", "completed", "active"]),
                                    _createVNode(_component_WizardItem, {
                                      title: _ctx.$t('views.portal.cases.content.stepsDetail.modalitesEntreprise'),
                                      icon: "fa-solid fa-money-bill",
                                      completed: [3].includes(dossier.etapeStatus.find(e => e.type === 'modalites_employeur')?.status),
                                      active: [2, 5].includes(dossier.etapeStatus.find(e => e.type === 'modalites_employeur')?.status),
                                      isLast: false
                                    }, null, 8, ["title", "completed", "active"]),
                                    _createVNode(_component_WizardItem, {
                                      title: _ctx.$t('views.portal.cases.content.stepsDetail.fiche'),
                                      icon: "fa-solid fa-file-lines",
                                      completed: [3].includes(dossier.etapeStatus.find(e => e.type === 'fre')?.status) && [3].includes(dossier.etapeStatus.find(e => e.type === 'fra')?.status),
                                      active: [2].includes(dossier.etapeStatus.find(e => e.type === 'fre')?.status) || [2].includes(dossier.etapeStatus.find(e => e.type === 'fra')?.status),
                                      isLast: false
                                    }, null, 8, ["title", "completed", "active"]),
                                    _createVNode(_component_WizardItem, {
                                      title: _ctx.$t('views.portal.cases.content.stepsDetail.contrat'),
                                      icon: "fa-solid fa-building-circle-check",
                                      completed: [3].includes(dossier.etapeStatus.find(e => e.type === 'cfa')?.status),
                                      active: [2].includes(dossier.etapeStatus.find(e => e.type === 'cfa')?.status),
                                      isLast: false
                                    }, null, 8, ["title", "completed", "active"]),
                                    _createVNode(_component_WizardItem, {
                                      title: _ctx.$t('views.portal.cases.content.stepsDetail.signature'),
                                      icon: "fa-solid fa-circle-check",
                                      completed: [3].includes(dossier.etapeStatus.find(e => e.type === 'signature_ecole')?.status),
                                      active: 
                              [1, 2].includes(dossier.etapeStatus.find(e => e.type === 'signature_admissible')?.status) ||
                              [1, 2].includes(dossier.etapeStatus.find(e => e.type === 'signature_employeur')?.status) ||
                              [1, 2].includes(dossier.etapeStatus.find(e => e.type === 'signature_ecole')?.status)
                            ,
                                      isLast: true
                                    }, null, 8, ["title", "completed", "active"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["id-key", "expanded"])
                  ]))
                }), 128))
              ]),
              _: 1
            }, 8, ["title"])
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.dossiers.length)
        ? (_openBlock(), _createBlock(_component_BasicCard, {
            key: 1,
            id: "documents",
            class: "mb-10",
            title: _ctx.$t('views.portal.cases.uploadArea.title')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_AdmissibleDocuments)
            ]),
            _: 1
          }, 8, ["title"]))
        : _createCommentVNode("", true)
    ])
  ]))
}